import React, { useState, useEffect, useRef } from "react";

const Navbar = ({ darkMode, setDarkMode, scrollToSection, mainRef, aboutRef, servicesRef, contactRef, projectsRef, activeSection }) => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Toggle Theme
  const toggleTheme = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle("dark-mode");
  };

  // Show Navbar on Scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowNavbar(window.scrollY < lastScrollY);
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // Close Navbar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="w-100 d-flex justify-content-center">
      <nav ref={menuRef} className={`navbar navbar-expand-lg container mt-00 mt-4 rounded-3 ${darkMode ? "navbar-dark bg-dark" : "navbar-light bglight-mode"} ${showNavbar ? "visible" : "hidden"}`}>
        <div className="container">
          <button className="nav-link" onClick={() => scrollToSection(mainRef)}>
            <span className="responsive-Htext fw-bold"  ><span className="nav-home">A</span>hmed<span className="nav-home">E</span>lgaml</span>
          </button>
          <button className="navbar-toggler" type="button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="navbarNav">
            <ul className="navbar-nav ms-auto me-2">
              {[
                { name: "Home", ref: mainRef, section: "main" },
                { name: "About", ref: aboutRef, section: "about" },
                { name: "Services", ref: servicesRef, section: "services" },
                { name: "Projects", ref: projectsRef, section: "projects" },
                { name: "Contact", ref: contactRef, section: "contact" },
              ].map(({ name, ref, section }) => (
                <li className="nav-item" key={section}>
                  <button
                    className="nav-link"
                    onClick={() => {
                      scrollToSection(ref);
                      setIsMenuOpen(false);
                    }}
                    style={{
                      borderBottom: activeSection === section ? "3px solid #c2b41e" : "none",
                      transition: "border-bottom 0.3s ease-in-out",
                    }}
                  >
                    {name}
                  </button>
                </li>
              ))}
            </ul>
            <button className="btn btn-outline-dark" onClick={toggleTheme}>
              <i className={`bi ${darkMode ? "bi-sun text-light" : "bi-moon"}`}></i>
            </button>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
